(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cuore-adapter-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var button = document.querySelector('[data-cuore-adapter-add]');
    if (!button) return;

    var errorEl = document.querySelector('[data-cuore-adapter-error]');

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = !message;
    }

    button.addEventListener('click', function () {
      if (button.disabled) return;

      var variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      button.disabled = true;
      showError('');

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) {
              throw new Error(body.description || body.message || 'Unable to add item to cart.');
            }
            return body;
          });
        })
        .then(function () {
          if (window.CuoreCart && typeof window.CuoreCart.refresh === 'function') {
            return window.CuoreCart.refresh().then(function () {
              window.CuoreCart.open();
            });
          }

          var cartTrigger = document.querySelector('[data-cuore-cart-open]');
          if (cartTrigger) {
            cartTrigger.click();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          showError(error.message || 'Unable to add item to cart.');
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuore-buy-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bar = document.getElementById('CuoreBuyBar');
  if (!bar) return;

  if (document.documentElement.classList.contains('shopify-design-mode')) {
    bar.setAttribute('aria-hidden', 'false');
    return;
  }

  /* Start hidden (inert + aria-hidden) until observer fires */
  bar.setAttribute('inert', '');

  var hero = document.querySelector('[data-cuore-hero]');
  if (!hero) {
    /* No hero on this page — show bar immediately */
    bar.classList.add('is-visible');
    bar.removeAttribute('inert');
    bar.setAttribute('aria-hidden', 'false');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
        bar.setAttribute('inert', '');
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
        bar.removeAttribute('inert');
      }
    },
    { threshold: 0 }
  );

  observer.observe(hero);

  /*
   * "Notify me" CTA — scroll to the very top of the hero so the parallax
   * background is at translateY(0) with no gap, then focus the email input.
   * Using a JS scroll instead of a bare anchor avoids the browser's
   * scroll-into-view logic which only moves the minimum distance needed.
   */
  var notifyLink = bar.querySelector('a[href="#CuoreNotifyHero"]');
  if (notifyLink) {
    notifyLink.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      /* Focus the email input after the scroll settles */
      var focusInput = function () {
        var form = document.getElementById('CuoreNotifyHero');
        if (!form) return;
        var emailInput = form.querySelector('input[type="email"]');
        if (emailInput) emailInput.focus();
      };
      /* 600 ms covers the smooth-scroll duration on most browsers */
      setTimeout(focusInput, 600);
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuore-cart"]) return;
  try {
    
(function () {
  'use strict';

  var form = document.getElementById('CuoreCartForm');
  if (!form) return;

  var termsCheckbox = form.querySelector('[data-cuore-terms-checkbox]');
  var checkoutBtn = form.querySelector('[data-cuore-action="checkout"]');

  function updateGate() {
    var termsOk = !termsCheckbox || termsCheckbox.checked;
    checkoutBtn.disabled = !termsOk;
  }

  if (checkoutBtn) {
    if (termsCheckbox) termsCheckbox.addEventListener('change', updateGate);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cuore-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ── Cart badge: hide when zero, reflect drawer aria-expanded ── */
  (function () {
    var badge = document.querySelector('[data-cuore-header-cart-count]');
    var drawer = document.querySelector('.cuore-cart-drawer');
    var cartBtn = document.querySelector('[data-cuore-cart-open]');

    if (badge) {
      function syncBadge() {
        var n = parseInt(badge.textContent || '0', 10);
        badge.style.opacity = n === 0 ? '0' : '';
      }
      new MutationObserver(syncBadge).observe(badge, { childList: true, characterData: true, subtree: true });
      syncBadge();
    }

    if (drawer && cartBtn) {
      var _lastCartOpenFocus = null;
      new MutationObserver(function () {
        var open = drawer.classList.contains('is-open');
        cartBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          _lastCartOpenFocus = document.activeElement;
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

      /* Return focus to cart button when drawer closes */
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (!drawer.classList.contains('is-open')) return;
        var overlay = document.querySelector('.cuore-cart-overlay');
        if (overlay) overlay.click();
        cartBtn.focus();
      });
    }
  })();

  /* ── Mobile nav drawer (only present in the DOM when has_menu is true) ── */
  (function () {
    var FOCUSABLE = 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var navDrawer = document.getElementById('CuoreNavDrawer');
    var navOverlay = document.querySelector('.cuore-nav-overlay');
    var hamburger = document.querySelector('[data-cuore-nav-open]');
    var _trigger = null;

    function openNav() {
      if (!navDrawer) return;
      _trigger = document.activeElement;
      navDrawer.classList.add('is-open');
      navDrawer.setAttribute('aria-hidden', 'false');
      if (navOverlay) navOverlay.classList.add('is-open');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = navDrawer.querySelector(FOCUSABLE);
      if (first) first.focus();
    }

    function closeNav() {
      if (!navDrawer) return;
      navDrawer.classList.remove('is-open');
      navDrawer.setAttribute('aria-hidden', 'true');
      if (navOverlay) navOverlay.classList.remove('is-open');
      if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (_trigger && typeof _trigger.focus === 'function') {
        _trigger.focus();
        _trigger = null;
      }
    }

    if (hamburger) {
      hamburger.addEventListener('click', function () {
        navDrawer && navDrawer.classList.contains('is-open') ? closeNav() : openNav();
      });
    }

    /* All elements with [data-cuore-nav-close] close the drawer */
    document.querySelectorAll('[data-cuore-nav-close]').forEach(function (el) {
      el.addEventListener('click', closeNav);
    });

    /* ESC closes nav drawer */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && navDrawer && navDrawer.classList.contains('is-open')) {
        closeNav();
      }
    });

    /* Focus trap */
    if (navDrawer) {
      navDrawer.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = Array.from(navDrawer.querySelectorAll(FOCUSABLE));
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-support-apps"] && !Shopify.designMode) return;
  try {
    
  // Progressive enhancement: flag the visitor's platform so the matching store
  // card carries a "Your device" badge. Both cards stay available regardless.
  (function () {
    function markCurrentDevice(root) {
      var ua = navigator.userAgent || '';
      var platform = '';

      if (/iPhone|iPad|iPod/i.test(ua)) {
        platform = 'ios';
      } else if (/Android/i.test(ua)) {
        platform = 'android';
      }

      if (!platform) return;

      var card = root.querySelector('[data-ps-platform="' + platform + '"]');
      if (!card) return;

      card.classList.add('is-current-device');

      var badge = card.querySelector('[data-ps-badge]');
      if (badge) badge.hidden = false;
    }

    function init() {
      document.querySelectorAll('[data-ps-apps][data-ps-detect]').forEach(markCurrentDevice);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Re-run when the section is re-rendered in the theme editor.
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
